import { WebPlugin } from '@capacitor/core';
export class UpdaterWeb extends WebPlugin {
    async downloadBundle(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    async setNextBundle(_options) {
        throw this.unimplemented('Not implemented on web.');
    }
    async getCurrentBundle() {
        throw this.unimplemented('Not implemented on web.');
    }
    async reload() {
        throw this.unimplemented('Not implemented on web.');
    }
    async rollback() {
        throw this.unimplemented('Not implemented on web.');
    }
    async notifyReady() {
        throw this.unimplemented('Not implemented on web.');
    }
}
//# sourceMappingURL=web.js.map